var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk, gqlSdkAccount } from '@cta-portal/webapp-common/lib/api/client';
import { ethers } from 'ethers';
import { useCallback, useContext, useEffect, useState } from 'react';
import { x } from '@imtbl/sdk';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
import { appEnv as commonAppEnv } from '@cta-portal/webapp-common/lib/env';
import { WalletConnectionType } from '../../types/blockchain';
import { LoadingContext } from '../loading';
import { useMagicLinkContext } from './magic-link/hook';
export var LOCAL_STORAGE_SELECTED_WALLET_ADDRESS_KEY = 'selected-wallet-address';
export var LOCAL_STORAGE_LOCAL_WALLET_ADDRESS_KEY = 'local-wallet-address';
export function useUserContext() {
    var _this = this;
    var magicLinkContext = useMagicLinkContext();
    var setImxLoading = useContext(LoadingContext).setImxLoading;
    var imxClient = useState(new x.IMXClient(x.imxClientConfig({ environment: appEnv.blockchain.imxConfig })))[0];
    var _a = useState(undefined), ctaServerMaintenance = _a[0], setCtaServerMaintenance = _a[1];
    var _b = useState(undefined), systemInfo = _b[0], setSystemInfo = _b[1];
    var _c = useState(undefined), user = _c[0], setUser = _c[1];
    var _d = useState(undefined), user2 = _d[0], setUser2 = _d[1];
    var _e = useState(undefined), selectedWallet = _e[0], setSelectedWallet = _e[1];
    var _f = useState(localStorage.getItem(LOCAL_STORAGE_LOCAL_WALLET_ADDRESS_KEY) || undefined), localWalletAddress = _f[0], setLocalWalletAddress = _f[1];
    var _g = useState(undefined), balances = _g[0], setBalances = _g[1];
    var _h = useState(undefined), fees = _h[0], setFees = _h[1];
    useEffect(function () { }, []);
    var getBalances = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var ctaWalletBalances, _a, cta, gameWalletBalances, _b, game, customWalletBalances, _c, custom, localWalletBalances, _d, local;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!imxClient)
                        return [2 /*return*/];
                    setImxLoading(balances === undefined);
                    if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress)) return [3 /*break*/, 2];
                    return [4 /*yield*/, imxClient.listBalances({ owner: (user === null || user === void 0 ? void 0 : user.mpcWalletAddress) || '' })];
                case 1:
                    _a = _e.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = undefined;
                    _e.label = 3;
                case 3:
                    ctaWalletBalances = _a;
                    cta = (ctaWalletBalances === null || ctaWalletBalances === void 0 ? void 0 : ctaWalletBalances.result)
                        ? ctaWalletBalances.result.filter(function (balance) {
                            return balance.symbol === CurrencyTokenSymbol.USDC ||
                                balance.symbol === CurrencyTokenSymbol.CTA ||
                                balance.symbol === CurrencyTokenSymbol.ETH ||
                                balance.symbol === CurrencyTokenSymbol.IMX;
                        })
                        : undefined;
                    if (!(user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress)) return [3 /*break*/, 5];
                    return [4 /*yield*/, imxClient.listBalances({ owner: (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || '' })];
                case 4:
                    _b = _e.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _b = undefined;
                    _e.label = 6;
                case 6:
                    gameWalletBalances = _b;
                    game = (gameWalletBalances === null || gameWalletBalances === void 0 ? void 0 : gameWalletBalances.result)
                        ? gameWalletBalances.result.filter(function (balance) {
                            return balance.symbol === CurrencyTokenSymbol.USDC ||
                                balance.symbol === CurrencyTokenSymbol.CTA ||
                                balance.symbol === CurrencyTokenSymbol.ETH ||
                                balance.symbol === CurrencyTokenSymbol.IMX;
                        })
                        : undefined;
                    if (!(user === null || user === void 0 ? void 0 : user.coldWalletAddress)) return [3 /*break*/, 8];
                    return [4 /*yield*/, imxClient.listBalances({ owner: (user === null || user === void 0 ? void 0 : user.coldWalletAddress) || '' })];
                case 7:
                    _c = _e.sent();
                    return [3 /*break*/, 9];
                case 8:
                    _c = undefined;
                    _e.label = 9;
                case 9:
                    customWalletBalances = _c;
                    custom = (customWalletBalances === null || customWalletBalances === void 0 ? void 0 : customWalletBalances.result)
                        ? customWalletBalances.result.filter(function (balance) {
                            return balance.symbol === CurrencyTokenSymbol.USDC ||
                                balance.symbol === CurrencyTokenSymbol.CTA ||
                                balance.symbol === CurrencyTokenSymbol.ETH ||
                                balance.symbol === CurrencyTokenSymbol.IMX;
                        })
                        : undefined;
                    if (!(localWalletAddress &&
                        localWalletAddress !== (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) &&
                        localWalletAddress !== (user === null || user === void 0 ? void 0 : user.coldWalletAddress))) return [3 /*break*/, 11];
                    return [4 /*yield*/, imxClient.listBalances({ owner: localWalletAddress || '' })];
                case 10:
                    _d = _e.sent();
                    return [3 /*break*/, 12];
                case 11:
                    _d = undefined;
                    _e.label = 12;
                case 12:
                    localWalletBalances = _d;
                    local = (localWalletBalances === null || localWalletBalances === void 0 ? void 0 : localWalletBalances.result)
                        ? localWalletBalances.result.filter(function (balance) {
                            return balance.symbol === CurrencyTokenSymbol.USDC ||
                                balance.symbol === CurrencyTokenSymbol.CTA ||
                                balance.symbol === CurrencyTokenSymbol.ETH ||
                                balance.symbol === CurrencyTokenSymbol.IMX;
                        })
                        : undefined;
                    setBalances({
                        cta: cta,
                        game: game,
                        custom: custom,
                        local: local,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [imxClient, user, localWalletAddress]);
    useEffect(function () {
        // async function checkMaintenance() {
        //   try {
        //     const response = await gqlSdk.SystemIsInMaintenance()
        //     setCtaServerMaintenance(
        //       response
        //         ? response.systemIsInMaintenance.isInMaintenance && localStorage.getItem('ignore-maintenance') !== 'true'
        //         : true,
        //     )
        //   } catch (err) {
        //     console.error(err)
        //     setCtaServerMaintenance(true)
        //   }
        // }
        function getSystemInfo() {
            return __awaiter(this, void 0, void 0, function () {
                var response, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, gqlSdk.SystemGetInfo()];
                        case 1:
                            response = _a.sent();
                            setSystemInfo(response ? response.systemGetInfo : undefined);
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            console.error(err_1);
                            setSystemInfo(null);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        // checkMaintenance()
        setCtaServerMaintenance(false);
        getSystemInfo();
        reconnectUser();
    }, []);
    useEffect(function () {
        if (ctaServerMaintenance || user === undefined)
            return;
        getBalances();
    }, [ctaServerMaintenance, user, getBalances]);
    function reconnectUser() {
        return __awaiter(this, void 0, void 0, function () {
            var response, userResponse, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, gqlSdkAccount.UserFindCurrent()];
                    case 1:
                        response = _a.sent();
                        userResponse = response && response.userFindCurrent && response.userFindCurrent.uuid ? response.userFindCurrent : null;
                        if (!userResponse) {
                            globalThis.location.href = "".concat(commonAppEnv.server.ssoUrl, "/login?ref=").concat(encodeURIComponent("".concat(commonAppEnv.client.portalUrl, "/")));
                        }
                        setUser2(userResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2);
                        setUser(null);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        function updateFees() {
            return __awaiter(this, void 0, void 0, function () {
                var mintPasses;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!user) return [3 /*break*/, 2];
                            return [4 /*yield*/, gqlSdk.MintPassFindMany()];
                        case 1:
                            mintPasses = _a.sent();
                            if (mintPasses.mintPassFindMany.length > 0) {
                                setFees({ protocol: 2, royalties: 3, marketplace: 0, buyer: 0, seller: 0 });
                            }
                            else if (Number.parseInt(user.ctaTokenCountDeci18) >= 50000000000000000000) {
                                setFees({ protocol: 2, royalties: 3, marketplace: 0.5, buyer: 0.25, seller: 0.25 });
                            }
                            else {
                                setFees({ protocol: 2, royalties: 3, marketplace: 1, buyer: 0.5, seller: 0.5 });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            setFees({ protocol: 2, royalties: 3, marketplace: 2, buyer: 1, seller: 1 });
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        if (user !== undefined)
            updateFees();
    }, [user]);
    // async function checkMagicLinkImxRegistration(currentUser: User) {
    //   const { magic } = magicLinkContext
    //   const walletAddress = currentUser?.magicLinkWalletAddress
    //   if (!magic || !currentUser || !currentUser.email || !walletAddress) return
    //   try {
    //     await imxClient.getUser(walletAddress)
    //   } catch {
    //     const magicIsLoggedIn = await magic.user.isLoggedIn()
    //     if (magicIsLoggedIn) await magic.user.logout()
    //     await magicLinkContext.loginWithMagicLink(currentUser.email)
    // const provider = new ethers.BrowserProvider(magic.rpcProvider)
    // const ethSigner = await provider.getSigner()
    // const starkPrivateKey = await x.generateLegacyStarkPrivateKey(ethSigner)
    // const starkSigner = x.createStarkSigner(starkPrivateKey)
    // const imxProvider = new x.GenericIMXProvider(
    //   new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }),
    //   ethSigner,
    //   starkSigner,
    // )
    //     try {
    //       await imxProvider.registerOffchain()
    //     } catch (err) {
    //       if (err instanceof Error) {
    //         console.log(err.message)
    //       }
    //     }
    //   }
    // }
    function checkMetamaskImxRegistration() {
        return __awaiter(this, void 0, void 0, function () {
            var _a, provider, ethSigner, starkPrivateKey, starkSigner, imxProvider, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!window.ethereum || !window.ethereum.selectedAddress)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 10]);
                        return [4 /*yield*/, imxClient.getUser(window.ethereum.selectedAddress)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 3:
                        _a = _b.sent();
                        provider = new ethers.BrowserProvider(window.ethereum);
                        return [4 /*yield*/, provider.getSigner()];
                    case 4:
                        ethSigner = _b.sent();
                        return [4 /*yield*/, x.generateLegacyStarkPrivateKey(ethSigner)];
                    case 5:
                        starkPrivateKey = _b.sent();
                        starkSigner = x.createStarkSigner(starkPrivateKey);
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), ethSigner, starkSigner);
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, imxProvider.registerOffchain()];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        err_3 = _b.sent();
                        if (err_3 instanceof Error) {
                            console.log(err_3.message);
                        }
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    function updateSelectedWallet(address, currentUser) {
        if (address === undefined) {
            setSelectedWallet(undefined);
            return;
        }
        var userToCheck = currentUser || user;
        var connectionType = WalletConnectionType.MPC;
        var magicLinkWalletAddress = userToCheck === null || userToCheck === void 0 ? void 0 : userToCheck.magicLinkWalletAddress;
        if (address === (userToCheck === null || userToCheck === void 0 ? void 0 : userToCheck.mpcWalletAddress)) {
            connectionType = WalletConnectionType.MPC;
            magicLinkWalletAddress = userToCheck.magicLinkWalletAddress;
        }
        if (address === (userToCheck === null || userToCheck === void 0 ? void 0 : userToCheck.magicLinkWalletAddress))
            connectionType = WalletConnectionType.MAGIC_LINK;
        if (address === (userToCheck === null || userToCheck === void 0 ? void 0 : userToCheck.coldWalletAddress))
            connectionType = WalletConnectionType.METAMASK;
        if (address === localWalletAddress)
            connectionType = WalletConnectionType.METAMASK;
        localStorage.setItem(LOCAL_STORAGE_SELECTED_WALLET_ADDRESS_KEY, address);
        setSelectedWallet({
            address: address,
            connectionType: connectionType,
            email: (userToCheck === null || userToCheck === void 0 ? void 0 : userToCheck.email) || undefined,
            magicLinkWalletAddress: magicLinkWalletAddress,
        });
    }
    function addLocalWallet(address) {
        localStorage.setItem(LOCAL_STORAGE_LOCAL_WALLET_ADDRESS_KEY, address);
        setLocalWalletAddress(address);
        setSelectedWallet({
            address: address,
            connectionType: WalletConnectionType.METAMASK,
        });
        checkMetamaskImxRegistration();
    }
    function removeLocalWallet() {
        localStorage.removeItem(LOCAL_STORAGE_LOCAL_WALLET_ADDRESS_KEY);
        var walletToSelect;
        if (user === null || user === void 0 ? void 0 : user.mpcWalletAddress) {
            walletToSelect = {
                address: user.mpcWalletAddress,
                connectionType: WalletConnectionType.MPC,
                email: user.email || undefined,
                magicLinkWalletAddress: user.magicLinkWalletAddress,
            };
        }
        else if (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) {
            walletToSelect = {
                address: user.magicLinkWalletAddress,
                connectionType: WalletConnectionType.MAGIC_LINK,
                email: user.email || undefined,
            };
        }
        else if (user === null || user === void 0 ? void 0 : user.coldWalletAddress) {
            walletToSelect = {
                address: user.coldWalletAddress,
                connectionType: WalletConnectionType.METAMASK,
            };
        }
        setLocalWalletAddress(undefined);
        setSelectedWallet(walletToSelect);
    }
    return {
        ctaServerMaintenance: ctaServerMaintenance,
        systemInfo: systemInfo,
        user: user,
        user2: user2,
        balances: balances,
        fees: fees,
        magicLinkContext: magicLinkContext,
        selectedWallet: selectedWallet,
        localWalletAddress: localWalletAddress,
        reconnectUser: reconnectUser,
        getBalances: getBalances,
        setSelectedWallet: updateSelectedWallet,
        addLocalWallet: addLocalWallet,
        removeLocalWallet: removeLocalWallet,
    };
}
